import React from 'react';
import cn from 'classnames';

export const LoadingSkeleton: React.FC<{
  heightClassName: string;
  widthClassName?: string;
}> = ({ heightClassName, widthClassName }) => {
  return (
    <div
      className={cn(
        'bg-gray-200 rounded animate-[pulse_1.5s_ease-in-out_infinite]',
        heightClassName,
        widthClassName ?? 'w-full',
      )}
    />
  );
};
